<template>
  <div class="the-regular-advisor">
    <div class="left-wrap">
      <div class="left-title">
        Weeks
      </div>

      <a-button style="margin-bottom: 10px;" @click="handleWeek">
        {{ $t('handle.edit') }}
      </a-button>

      <!-- 表格 -->
      <a-table
        size="middle"
        :showHeader="false"
        :rowKey="record => record.id"
        :loading="weekTableLoading"
        :dataSource="weekDataSource"
        :pagination="false"
        :rowClassName="record => (weekId === record.id ? 'selected-row' : '')"
        :customRow="
          record => {
            return {
              style: {
                cursor: 'pointer'
              },
              on: {
                click: () => {
                  if (weekId === record.id) {
                    return
                  }
                  weekInfo = record
                  weekId = record.id
                  submitDisabled = record.submitStatus === 1
                }
              }
            }
          }
        "
      >
        <a-table-column
          :width="170"
          title="weeks"
          dataIndex="weeks"
        ></a-table-column>

        <a-table-column title="submitStatus" dataIndex="submitStatus">
          <template slot-scope="submitStatus">
            <a-icon v-if="submitStatus === 1" type="check" />
          </template>
        </a-table-column>
      </a-table>
    </div>

    <div class="right-wrap" v-if="!!weekId">
      <div class="grade-title">
        {{ weekInfo.weeks }}
        <a-button :disabled="submitDisabled" @click="handleSubmit">
          {{ $t('handle.submit') }}
        </a-button>
      </div>

      <!-- 表格 -->
      <a-table
        size="middle"
        :rowKey="record => record.id"
        :loading="studentTableLoading"
        :dataSource="studentDataSource"
        :pagination="false"
      >
        <a-table-column
          :width="120"
          title="#"
          dataIndex="studentNo"
        ></a-table-column>

        <a-table-column
          :width="100"
          :title="$t('public.name')"
          dataIndex="name"
        ></a-table-column>

        <a-table-column
          :width="140"
          :title="$t('public.englishName')"
          dataIndex="englishName"
        >
          <template slot-scope="englishName, record">
            {{ record.surname }} {{ record.givenName }} ({{
              record.englishName
            }})
          </template>
        </a-table-column>

        <a-table-column
          :title="$t('public.comments')"
          dataIndex="basicGradeFeedback.comment"
        ></a-table-column>

        <a-table-column
          :width="100"
          :title="$t('public.operate')"
          align="right"
          dataIndex="handles"
          v-if="handleRightsList.includes('班主任评语')"
        >
          <template slot-scope="handles, record">
            <a
              href="javascript:;"
              v-if="record.basicGradeFeedback.basicFeedbackStatus === 0"
              @click="editItem(record)"
            >
              {{ $t('handle.edit') }}
            </a>
            <a
              href="javascript:;"
              v-else-if="
                record.basicGradeFeedback.basicFeedbackStatus === 1 ||
                  record.basicGradeFeedback.basicFeedbackStatus === 2 ||
                  record.basicGradeFeedback.basicFeedbackStatus === 4
              "
              @click="editItem(record)"
            >
              {{ $t('handle.reedit') }}
            </a>
            <span
              class="grade-status"
              v-else-if="record.basicGradeFeedback.basicFeedbackStatus === 5"
            >
              {{ $t('public.checkPending') }}
            </span>
          </template>
        </a-table-column>
      </a-table>
    </div>

    <a-modal
      :width="700"
      :title="$t('grades.editWeek')"
      v-model="weekModalVisible"
      :confirmLoading="weekModalLoading"
      :afterClose="weekAfterClose"
      @ok="weekOk"
    >
      <a-form
        :form="weekForm"
        :labelCol="{ span: $i18n.locale === 'zh_CN' ? 4 : 6 }"
        :wrapperCol="{ span: $i18n.locale === 'zh_CN' ? 19 : 17 }"
      >
        <a-form-item :label="$t('grades.weeks')">
          <a-checkbox-group v-decorator="['weeks']">
            <a-row style="margin-top: 5px;">
              <a-col
                v-for="item in weekList"
                :key="item.id"
                :span="12"
                style="padding: 5px 0;"
              >
                <a-checkbox :value="item.id">
                  {{ item.weeks }}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal
      :title="$t('public.edit', { content: '' })"
      v-model="modalVisible"
      :confirmLoading="modalLoading"
      :afterClose="afterClose"
      @ok="ok"
    >
      <a-form :form="form">
        <a-form-item
          :label="$t('public.comments')"
          :extra="
            `${
              form.getFieldValue('comment')
                ? form.getFieldValue('comment').length
                : '0'
            }/500`
          "
          :labelCol="formItemLayout.labelCol"
          :wrapperCol="formItemLayout.wrapperCol"
        >
          <a-textarea
            maxLength="500"
            :autosize="{ minRows: 3, maxRows: 5 }"
            :placeholder="$t('public.comments')"
            v-decorator="[
              'comment',
              {
                rules: [
                  {
                    required: true,
                    message: $t('public.pleaseFill', {
                      content: $t('public.comments_lower')
                    })
                  }
                ]
              }
            ]"
          >
          </a-textarea>
        </a-form-item>

        <!-- <a-alert
          v-if="basicFeedbackStatus"
          :message="$t('report.reeditTip')"
          type="warning"
        /> -->
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    classId: {
      type: [String, Number],
      required: true
    },
    academic: {
      type: [String, Number],
      required: true
    },
    semester: {
      type: [String, Number],
      required: true
    },
    grade: {
      type: [String, Number],
      required: true
    }
  },

  data() {
    return {
      weekTableLoading: false,
      weekDataSource: [],

      // 编辑教学周
      weekModalVisible: false,
      weekModalLoading: false,
      weekForm: this.$form.createForm(this),
      weekId: undefined,
      weekInfo: {},
      submitDisabled: true,

      // 学生
      studentTableLoading: false,
      studentDataSource: [],
      studentId: undefined,
      gradeId: undefined,
      basicFeedbackStatus: false,

      modalVisible: false,
      modalLoading: false,
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 18 }
      },
      weekList: [
        'Week1（SEP.14 - SEP.20）',
        'Week2（SEP.21 - SEP.27）',
        'Week3（SEP.28 - OCT.4）',
        'Week4（OCT.5 - OCT.11）',
        'Week5（OCT.12 - OCT.18）',
        'Week6（OCT.19 - OCT.25）',
        'Week7（OCT.26 - NOV.1）',
        'Week8（NOV.2 - NOV.8）',
        'Week9（NOV.9 - NOV.15）',
        'Week10（NOV.16 - NOV.22）',
        'Week11（NOV.23 - NOV.29）',
        'Week12（NOV.30 - DEC.6）',
        'Week13（DEC.7 - DEC.13）',
        'Week14（DEC.14 - DEC.20）',
        'Week15（DEC.21 - DEC.27）',
        'Week16（DEC.28 - JAN.3）',
        'Week17（JAN.4 - JAN.10）',
        'Week18（JAN.11 - JAN.17）',
        'Week19（JAN.18 - JAN.24）',
        'Week20（JAN.25 - JAN.31）',
        'Week21（FEB.1 - FEB.7）',
        'Week22（FEB.8 - FEB.14）',
        'Week23（FEB.15 - FEB.21）',
        'Week24（FEB.22 - FEB.28）'
      ]
    }
  },

  computed: {
    ...mapGetters(['handleRightsList'])
  },

  watch: {
    classId() {
      this.getWeek()
    },
    weekId() {
      this.weekId && this.getBasicStudentDataSource()
    }
  },

  created() {
    this.getWeek()
    this.getWeekListData()
  },

  methods: {
    getWeekListData() {
      this.$http(this.$api.getWeekListAll, {
        academic: this.academic,
        semester: this.semester
      }).then(r => {
        this.weekList = r.data || []
      })
    },
    getAllWeekList() {
      this.$http(this.$api.SUBMITADVISORFEEDBACK, {
        classId: this.classId,
        feedbackWeeksId: this.weekId
      })
        .then(() => {
          this.getWeek()
          this.$message.success(this.$t('public.saveSuccess'))
        })
        .catch(() => {
          this.submitDisabled = false
        })
    },
    // 教学周
    getWeek() {
      this.weekTableLoading = true
      this.$http(this.$api.GETADVISORWEEK, {
        academic: this.academic,
        semester: this.semester,
        classId: this.classId
      }).then(r => {
        this.weekTableLoading = false
        this.weekDataSource = r.data || []
        if (this.weekDataSource.length > 0) {
          if (this.weekId) {
            let haveWeek = false
            for (const item of this.weekDataSource) {
              if (item.id === this.weekId) {
                haveWeek = true
              }
            }
            if (!haveWeek) {
              this.weekInfo = this.weekDataSource[0]
              this.weekId = this.weekDataSource[0].id
              this.submitDisabled = this.weekDataSource[0].submitStatus === 1
            }
          } else {
            this.weekInfo = this.weekDataSource[0]
            this.weekId = this.weekDataSource[0].id
            this.submitDisabled = this.weekDataSource[0].submitStatus === 1
          }
        } else {
          this.weekInfo = {}
          this.weekId = undefined
          this.submitDisabled = false
        }
      })
    },

    handleWeek() {
      this.weekModalVisible = true
      const weeks = this.weekDataSource.map(item => {
        return item.weeks
      })
      this.$nextTick().then(() => {
        this.weekForm.setFieldsValue({
          weeks
        })
      })
    },

    weekOk() {
      this.weekForm.validateFields((err, values) => {
        if (!err) {
          this.handleSaveWeek(values)
        }
      })
    },

    handleSaveWeek(values) {
      this.weekModalLoading = true
      this.$http(this.$api.EDITADVISORWEEK, {
        classId: this.classId,
        weeks: JSON.stringify(values.weeks),
        academic: this.academic,
        semester: this.semester,
        grade: this.grade
      })
        .then(() => {
          this.getWeek()
          this.$message.success(this.$t('public.saveSuccess'))
          this.weekModalVisible = false
        })
        .catch(() => {
          this.weekModalLoading = false
        })
    },

    weekAfterClose() {
      this.weekForm.resetFields()
      this.weekModalLoading = false
    },

    // 班级里学生
    getBasicStudentDataSource() {
      this.studentTableLoading = true
      this.$http(this.$api.ADVISORFEEDBACK, {
        feedbackWeeksId: this.weekId,
        classId: this.classId
      }).then(r => {
        this.studentDataSource = r.data || []
        this.studentDataSource = this.studentDataSource.map(item => {
          return Object.assign(item, {
            basicGradeFeedback: item.basicGradeFeedback
              ? item.basicGradeFeedback
              : {
                  basicFeedbackStatus: 0
                }
          })
        })
        this.studentTableLoading = false
      })
    },

    // 提交成绩
    handleSubmit() {
      this.$confirm({
        title: this.$t('handle.submit'),
        content: this.$t('report.submitGradeTip'),
        onOk: () => {
          this.submitGrade()
        },
        onCancel() {}
      })
    },

    submitGrade() {
      this.submitDisabled = true
      this.$http(this.$api.SUBMITADVISORFEEDBACK, {
        classId: this.classId,
        feedbackWeeksId: this.weekId
      })
        .then(() => {
          this.getWeek()
          this.$message.success(this.$t('public.saveSuccess'))
        })
        .catch(() => {
          this.submitDisabled = false
        })
    },

    editItem(record) {
      this.studentId = record.id
      this.gradeId = record.basicGradeFeedback.id
      this.modalVisible = true
      this.basicFeedbackStatus =
        record.basicGradeFeedback.basicFeedbackStatus === 1 ||
        record.basicGradeFeedback.basicFeedbackStatus === 2 ||
        record.basicGradeFeedback.basicFeedbackStatus === 4
      this.$nextTick().then(() => {
        this.form.setFieldsValue({
          comment: record.basicGradeFeedback.comment
        })
      })
    },

    // 提交
    ok() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.handleSave(values)
        }
      })
    },

    handleSave(values) {
      this.modalLoading = true

      if (this.basicFeedbackStatus) {
        this.$http(this.$api.REEDITADVISORFEEDBACK, {
          id: this.gradeId,
          studentId: this.studentId, //学生ID
          feedbackWeeksId: this.weekId,
          comment: values.comment
        })
          .then(() => {
            this.getBasicStudentDataSource()
            this.$message.success(this.$t('public.saveSuccess'))
            this.modalVisible = false
          })
          .catch(() => {
            this.modalLoading = false
          })
      } else {
        this.$http(this.$api.EDITADVISORFEEDBACK, {
          studentId: this.studentId, //学生ID
          feedbackWeeksId: this.weekId,
          comment: values.comment
        })
          .then(() => {
            this.getBasicStudentDataSource()
            this.$message.success(this.$t('public.saveSuccess'))
            this.modalVisible = false
          })
          .catch(() => {
            this.modalLoading = false
          })
      }
    },

    afterClose() {
      this.form.resetFields()
      this.studentId = undefined
      this.gradeId = undefined
      this.modalLoading = false
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../style/variable.less';

.the-regular-advisor {
  min-height: calc(100% - 91px);
  display: flex;
  @timetableTypeWidth: 210px;
  .left-wrap {
    padding: 15px 5px;
    width: @timetableTypeWidth;
    border-right: 1px solid @lineColor;
    text-align: center;
    .left-title {
      font-size: @titleFontSize;
      font-weight: bold;
      margin-bottom: 10px;
    }
  }
  .right-wrap {
    padding: 15px;
    width: calc(~'100% - @{timetableTypeWidth}');
    display: flex;
    flex-direction: column;
    .grade-title {
      font-size: @titleFontSize;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    }
  }
}
</style>

<style lang="less">
@import '../../style/variable.less';

.the-regular-advisor {
  .subject-font {
    font-size: @titleFontSize;
  }
  .selected-row {
    background-color: @selectBackColor;
    &:hover:not(.ant-table-expanded-row) > td {
      background-color: @selectBackColor;
    }
  }
}
</style>
